import { FunctionComponent } from "react";

import { useEpisode } from "@/containers/Episode/context";
import { cx } from "@/utils";
import Highlight from "@components/Highlight";

import styles from "./TranscriptStatus.module.css";

const TranscriptStatus: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  const { episode_has_transcript, episode_transcript_status } = useEpisode();

  let label = null;

  if (episode_has_transcript) {
    if (episode_transcript_status === "queued") {
      label = L.TRANSCRIPTION_STATUS_QUEUED;
    } else if (episode_transcript_status === "indexed") {
      label = null;
    } else if (episode_transcript_status?.includes("failed")) {
      label = L.TRANSCRIPTION_STATUS_FAILED;
    } else {
      label = L.TRANSCRIPTION_STATUS_ONGOING;
    }
    // don't show if episode_has_transcript is undefined
  } else if (episode_has_transcript === false) {
    label = L.TRANSCRIPTION_STATUS_NOT_TRANSCRIBED;
  }

  return label ? (
    <Highlight
      className={cx(styles.root, className, {
        [styles.hasError]: episode_transcript_status?.includes("failed"),
      })}
      label={label}
    />
  ) : null;
};

export default TranscriptStatus;
